import { Building2, Shield, Trees, Users } from "lucide-react";

const HeroSection = () => {
  const stats = [
    { number: "700+", label: "Apartments", icon: Building2 },
    { number: "24/7", label: "Security", icon: Shield },
    { number: "40+", label: "Amenities", icon: Trees },
    { number: "2000+", label: "Residents", icon: Users },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image - LCP optimized */}
      <div
        className="absolute inset-0 bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('/hero-premium.webp')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundColor: '#f0f0f0',
          contentVisibility: 'auto',
        } as React.CSSProperties}
        data-fetchpriority="high"
      >
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/40 to-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full">
        <div className="section-container py-20 sm:py-32">
          <div className="text-center max-w-4xl mx-auto">


            {/* Main Heading */}
            <h1 className="text-5xl sm:text-7xl lg:text-8xl font-bold text-white mb-6 tracking-tight leading-tight drop-shadow-2xl">
              Purva Swanlake<br />
              <span className="text-4xl sm:text-6xl lg:text-7xl font-semibold text-white drop-shadow-lg">Apartment Owners Association</span>
            </h1>

            {/* Description */}
            <p className="text-lg sm:text-xl text-white mb-16 max-w-3xl mx-auto font-light drop-shadow-lg leading-relaxed">
              Official website of Purva Swanlake Apartment Owners' Association (PSAOA), representing 729 homes in Kelambakkam. Duly registered under the Tamil Nadu Societies Registration Act, 1975.
            </p>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-16">
              {stats.map((stat, index) => {
                const Icon = stat.icon;
                return (
                  <div
                    key={index}
                    className="bg-white/15 backdrop-blur-md border border-white/30 rounded-2xl p-6 sm:p-8 hover:bg-white/25 transition-all duration-300 hover:scale-110 transform"
                  >
                    <div className="flex justify-center mb-2">
                      <Icon className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
                    </div>
                    <div className="stat-number text-4xl sm:text-5xl font-bold text-white">{stat.number}</div>
                    <div className="stat-label text-white/90 font-medium">{stat.label}</div>
                  </div>
                );
              })}
            </div>

            {/* CTA */}
            <div className="mt-8">
              <a
                href="#about"
                className="inline-block bg-white text-blue-900 px-12 py-4 rounded-xl font-bold text-lg hover:bg-blue-50 transition-all duration-300 shadow-2xl hover:shadow-3xl hover:scale-105 transform active:scale-95"
              >
                Learn More
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
